import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import tw from 'twin.macro';

const styles = {
  tooltip: {
    '&': tw`bg-red-100 border border-red-500 text-red-500 pl-4 pr-8 py-3 rounded font-body text-sm border-l-4 text-left`,
  },
  arrow: {
    '&:before': tw`bg-red-500`,
  },
};

const ErrorTooltip = ({ classes, ...props }) => (
  // oxlint-disable-next-line react/jsx-props-no-spreading
  <Tooltip classes={classes} {...props} />
);

ErrorTooltip.propTypes = {
  // oxlint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object,
};

ErrorTooltip.defaultProps = {
  classes: undefined,
};

export default withStyles(styles)(ErrorTooltip);
